import React, { useState, useContext } from 'react';
import { Button, Progress } from 'rsuite';
import './bls-upload-excel.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../utils/i18n';
import { ActionLink, ModalWindow } from '../../atoms';
import { UserContext, FilterContext } from '../../../context';
import { BlsService } from '../../../services';
import { useDropzone } from 'react-dropzone';
import axios from '../../../utils/axios';
import Dropzone from 'react-dropzone';
import config from '../../../utils/config';

function UploadBlsExcel({ addAccountsModal, handleOpenSliderModal }) {
  const { filterDetails, setFilterDetails } = useContext(FilterContext);
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      '*.xlsx': [],
    },
    maxFiles: 1,
  });
  const [filesUploaded, setUploadedFiles] = useState(null);
  const [uploadpercent, setUploadPercent] = useState(0);
  const [fileUploadFailed, setFileUloadFailed] = useState(false);

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const handleOnCancel = e => {
    e.preventDefault();
    handleOpenSliderModal(false);
  };


  const decodeQueryParam = (p) => {
    return decodeURIComponent(p.replace(/\+/g, " "));
  }

  const onDrop = async files => {
    setUploadedFiles(files);
  };

  const onAdd = () => {
    onUpload();
  };

  const onUpload = async () => {
    const data = new FormData();
    data.append('file', filesUploaded[0]);
    try {
      let response = await axios.post(`${config.formUrl(BlsService.BLS_UPLOD_EXCEL)}`, data, {
        onUploadProgress: progressEvent => {
          const { loaded, total } = progressEvent;
          let precentage = Math.floor((loaded * 100) / total);
          setUploadPercent(precentage);
        },
        headers: {
          'x-access-token': userAccessToken,
          'x-user': username,
        },
        responseType: 'json',
      });
      setFileUloadFailed(false);
      handleOpenSliderModal(false, response?.data?.data);
    } catch (error) {
      setFileUloadFailed(true);
    }
  };

  return (
    <div>
      <div className="attr-delete accounts-add-container">
        <ModalWindow
          className="fqa-modal--addAccounts"
          isOpen={addAccountsModal}
          onRequestClose={handleOnCancel}
          heading={t('Upload Excel')}
          ariaHideApp={false}
          appElement={document.getElementById('app')}
        >
          <div className="container_excel">
            <Dropzone onDrop={onDrop} accept="image/png, image/gif">
              {({ getRootProps, getInputProps }) => (
                <section className="container">
                  {!filesUploaded?.length && (
                    <div {...getRootProps({ className: 'dropzone' })}>
                      <input {...getInputProps()} />
                      <p className="drag_file">{t('admin.add.drag')}</p>
                      <p className="drag_file"> {t('admin.add.or')}</p>
                      <p className="drag_file text_dec">{t('admin.add.browse')}</p>
                    </div>
                  )}
                  <aside>
                    {filesUploaded?.length && (
                      <ul className="dropzone uploaded_file">
                        <i className="eva  eva-file-outline"></i>&nbsp;{filesUploaded[0].name}
                      </ul>
                    )}
                  </aside>
                </section>
              )}
            </Dropzone>
          </div>
          <div className="progress">
            {uploadpercent > 0 && uploadpercent < 100 && (
              <Progress.Line percent={uploadpercent} status="active" />
            )}
          </div>
          {fileUploadFailed && <div className="error">{t('admin.excel.error')}</div>}

          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={t('reportTable.campaign.delete.cancel')}
              handleClick={handleOnCancel}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              disabled={!filesUploaded?.length}
              onClick={onAdd}
            >
              {t('admin.excel.upload')}
            </Button>
          </div>
        </ModalWindow>
      </div>
    </div>
  );
}
export default UploadBlsExcel;
